<template>
  <div class="footer-box">
    <div class="footer-content">
      <div class="footer-content-left">
        <ul>
          <li>
            <router-link to="/home">首页</router-link>
          </li>
          <i>|</i>
          <li>
            <router-link to="/product">产品中心</router-link>
          </li>
          <i>|</i>
          <li>
            <router-link to="/plan/planone">解决方案</router-link>
          </li>
          <i>|</i>
          <li>
            <router-link to="/pcuser">关于我们</router-link>
          </li>
          <i>|</i>
          <li>
            <a href="http://www.shebaochina.com" target="_blank">云生集团</a>
          </li>
        </ul>
        <p>
          <span>
            工作时间：
            <i>9:00-18:00 &nbsp;&nbsp;( 工作日 )</i>
          </span>
          <i>|</i>
          <span class="wx-content">
            <img src="../../../assets/image/weixin.png" alt />
            关注微信公众号
            <img
              class="weixin"
              src="../../../assets/image/weixinqrcode.png"
              alt
            />
          </span>
        </p>
        <p>
          版权所有@杭州人社云数据科技有限公司 Copyright 2018-2020
          杭州人社云数据科技有限公司 浙ICP备20028719号-1
        </p>
        <p>公司地址： 杭州市西湖区西溪龙湖天街蓝海引擎830A</p>
      </div>
      <div class="footer-content-right">
        <img src="../../../assets/image/homefooterlogo.png" alt />
        <p>4001-123330</p>
        <span>客户服务热线</span>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  computed: {
    getYear() {
      return new Date().getFullYear();
    }
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/footer.scss";
</style>



// WEBPACK FOOTER //
// src/components/mainContent/footer/index.vue